/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactSummary } from './ContactSummary.js';
import {
    ContactSummaryFromJSON,
    ContactSummaryFromJSONTyped,
    ContactSummaryToJSON,
} from './ContactSummary.js';
import type { CustomerPreview } from './CustomerPreview.js';
import {
    CustomerPreviewFromJSON,
    CustomerPreviewFromJSONTyped,
    CustomerPreviewToJSON,
} from './CustomerPreview.js';
import type { TaskStatusType } from './TaskStatusType.js';
import {
    TaskStatusTypeFromJSON,
    TaskStatusTypeFromJSONTyped,
    TaskStatusTypeToJSON,
} from './TaskStatusType.js';
import type { User } from './User.js';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User.js';

/**
 * 
 * @export
 * @interface Task
 */
export interface Task {
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof Task
     */
    dueDate?: Date;
    /**
     * 
     * @type {TaskStatusType}
     * @memberof Task
     */
    status?: TaskStatusType;
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    priority?: number;
    /**
     * 
     * @type {Date}
     * @memberof Task
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Task
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Task
     */
    dateDeleted?: Date;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    source?: string;
    /**
     * 
     * @type {User}
     * @memberof Task
     */
    assignedUser?: User;
    /**
     * 
     * @type {User}
     * @memberof Task
     */
    user?: User;
    /**
     * 
     * @type {CustomerPreview}
     * @memberof Task
     */
    customer?: CustomerPreview;
    /**
     * 
     * @type {ContactSummary}
     * @memberof Task
     */
    contact?: ContactSummary;
}

/**
 * Check if a given object implements the Task interface.
 */
export function instanceOfTask(value: object): boolean {
    return true;
}

export function TaskFromJSON(json: any): Task {
    return TaskFromJSONTyped(json, false);
}

export function TaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): Task {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'status': json['status'] == null ? undefined : TaskStatusTypeFromJSON(json['status']),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'dateDeleted': json['dateDeleted'] == null ? undefined : (new Date(json['dateDeleted'])),
        'source': json['source'] == null ? undefined : json['source'],
        'assignedUser': json['assignedUser'] == null ? undefined : UserFromJSON(json['assignedUser']),
        'user': json['user'] == null ? undefined : UserFromJSON(json['user']),
        'customer': json['customer'] == null ? undefined : CustomerPreviewFromJSON(json['customer']),
        'contact': json['contact'] == null ? undefined : ContactSummaryFromJSON(json['contact']),
    };
}

export function TaskToJSON(value?: Task | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'title': value['title'],
        'content': value['content'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'status': TaskStatusTypeToJSON(value['status']),
        'priority': value['priority'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'dateDeleted': value['dateDeleted'] == null ? undefined : ((value['dateDeleted']).toISOString()),
        'source': value['source'],
        'assignedUser': UserToJSON(value['assignedUser']),
        'user': UserToJSON(value['user']),
        'customer': CustomerPreviewToJSON(value['customer']),
        'contact': ContactSummaryToJSON(value['contact']),
    };
}

